import React, { useState } from 'react'
import { Row, Col, Card, CardHeader, CardBody, Collapse, Button, Label } from 'reactstrap'

import CustomInput from '../../../common/InputGroup'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import CustomNumberFormat from '../../ClickToCall/ClickToCall'
import CustomDatePicker from '../../../common/ReactDatePicker/ReactDatePicker'
import useGetStates from '../../../hooks/useGetStates'
import useGetSupportTable from '../../../hooks/useGetSupportTable'
import { COMPANY_TYPE, NATIONALITY, ORGANIZATION_TYPE } from '../../../constants/supportTypes'

const TableFilters = ({ optionsFromContactTable, changeOptionsData }) => {
  const [filters, setFilters] = useState({})
  const [isCollapseOpen, setIsCollapseOpen] = useState(false)
  const orgTypeOptions = useGetSupportTable(ORGANIZATION_TYPE)
  const statesOptions = useGetStates({ isAbbreviation: false })
  const nationalitiesOptions = useGetSupportTable(NATIONALITY)
  const companyTypeOptions = useGetSupportTable(COMPANY_TYPE)

  const toggleCollapseOpen = () => {
    setIsCollapseOpen(!isCollapseOpen)
  }

  const onChangeInput = (e) => {
    const { name, value } = e.target
    setFilters({ ...filters, [name]: value })
  }

  const onChangeInputFromTo = (name, value, field) => {
    setFilters({ ...filters, [name]: { ...filters[name], [field]: value } })
  }

  const onChangeSelect = (values, e) => {
    const { name } = e
    const newSelectedValues = []

    if (values) {
      values.forEach((value) => {
        newSelectedValues.push(value.value || value.id)
      })
      setFilters({ ...filters, [name]: newSelectedValues })
    } else {
      setFilters({ ...filters, [name]: [] })
    }
  }

  const onSearchClick = async () => {
    const newFilters = {}
    Object.keys(filters).forEach((filter) => {
      if (typeof filters[filter] === 'object' && !Array.isArray(filters[filter])) {
        const newFilter = {}
        for (const item in filters[filter]) {
          if (filters[filter][item]) {
            newFilter[item] = filters[filter][item]
          }
        }
        if (Object.keys(newFilter).length) {
          newFilters[filter] = newFilter
        }
        return
      } else if (filters[filter] || filters[filter] === '') {
        newFilters[filter] = filters[filter]
      }
    })
    const options = {
      ...optionsFromContactTable,
      tableFilter: { ...optionsFromContactTable.tableFilter, ...newFilters },
    }
    changeOptionsData(options)
    // await dispatch(getAllContacts(options))
  }

  return (
    <Card>
      <CardHeader
        onClick={toggleCollapseOpen}
        className='d-flex align-items-center justify-content-between'
        style={{ cursor: 'pointer' }}
      >
        <p className='m-0'>Filters</p>
        <i className={isCollapseOpen ? 'fas fa-angle-down fa-2x m-0' : 'fas fa-angle-up fa-2x m-0'}></i>
      </CardHeader>
      <Collapse isOpen={isCollapseOpen}>
        <CardBody>
          <Row>
            <Col md='3'>
              <CustomInput
                label='Name'
                type='text'
                value={filters.name || ''}
                onChange={onChangeInput}
                name='name'
                placeholder='Name...'
              />
            </Col>
            <Col md='3'>
              <CustomSelect
                label='Org. Type'
                defaultValue={filters.organization_type_id || []}
                onChange={onChangeSelect}
                options={orgTypeOptions}
                name='organization_type_id'
                placeholder='Please Select...'
                isClearable
                isMulti
              />
            </Col>
            <Col md='3'>
              <CustomInput
                label='Dot Number'
                type='text'
                value={filters.dot_number || ''}
                onChange={onChangeInput}
                name='dot_number'
                placeholder='Dot Number...'
              />
            </Col>
            <Col md='3'>
              <CustomInput
                label='MC Number'
                type='text'
                value={filters.mc_number || ''}
                onChange={onChangeInput}
                name='mc_number'
                placeholder='MC Number...'
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col md='3'>
              <CustomSelect
                label='State'
                defaultValue={filters.address_state || []}
                onChange={onChangeSelect}
                options={statesOptions}
                name='address_state'
                placeholder='Please Select...'
                isClearable
                isMulti
              />
            </Col>
            <Col md='3'>
              <Row>
                <Col md='6'>
                  <CustomInput
                    label='No. of trucks from'
                    type='number'
                    value={(filters.number_of_trucks && filters.number_of_trucks.from) || ''}
                    onChange={(e) => onChangeInputFromTo('number_of_trucks', e.target.value, 'from')}
                    name='number_of_trucks'
                    placeholder='No. of trucks from...'
                  />
                </Col>
                <Col md='6'>
                  <CustomInput
                    label='No. of trucks to'
                    type='number'
                    value={(filters.number_of_trucks && filters.number_of_trucks.to) || ''}
                    onChange={(e) => onChangeInputFromTo('number_of_trucks', e.target.value, 'to')}
                    name='number_of_trucks'
                    placeholder='No. of trucks to...'
                  />
                </Col>
              </Row>
            </Col>
            <Col md='3'>
              <CustomInput
                label='Company Owner'
                type='text'
                value={filters.owner_name || ''}
                onChange={onChangeInput}
                name='owner_name'
                placeholder='Company Owner...'
              />
            </Col>
            <Col md='3'>
              <CustomSelect
                label='Preferred Language'
                defaultValue={filters.nationality_id || []}
                onChange={onChangeSelect}
                options={nationalitiesOptions}
                name='nationality_id'
                placeholder='Please Select...'
                isClearable
                isMulti
              />
            </Col>
          </Row>
          <Row className={'mt-2'}>
            <Col md='3'>
              <CustomSelect
                label='Company Type'
                defaultValue={filters.company_type_id || []}
                onChange={onChangeSelect}
                options={companyTypeOptions}
                name='company_type_id'
                placeholder='Please Select...'
                isClearable
                isMulti
              />
            </Col>
            <Col md='3'>
              <Label>Business Phone</Label>
              <CustomNumberFormat
                className={'form-control-sm form-control'}
                name='business_phone'
                value={filters.business_phone || ''}
                placeholder='Business Phone...'
                type='tel'
                onChange={onChangeInput}
                format='(999) 999-9999'
                size={10}
                hidePhoneIcon
              />
            </Col>
            <Col md='3'>
              <CustomInput
                label='Email'
                type='text'
                value={filters.email || ''}
                onChange={onChangeInput}
                name='email'
                placeholder='Email...'
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col md='3'>
              <CustomDatePicker
                selected={
                  filters.last_contact_date && filters.last_contact_date.from
                    ? new Date(filters.last_contact_date.from)
                    : ''
                }
                onChange={(date) => onChangeInputFromTo('last_contact_date', date, 'from')}
                label='Last Contact Date from'
                isClearable
                placeholder='mm/dd/yyyy'
                dateFormat='MM/dd/yyyy'
              />
            </Col>
            <Col md='3'>
              <CustomDatePicker
                selected={
                  filters.last_contact_date && filters.last_contact_date.to
                    ? new Date(filters.last_contact_date.to)
                    : ''
                }
                onChange={(date) => onChangeInputFromTo('last_contact_date', date, 'to')}
                label='Last Contact Date to'
                isClearable
                placeholder='mm/dd/yyyy'
                dateFormat='MM/dd/yyyy'
              />
            </Col>
            <Col md='3'>
              <CustomDatePicker
                selected={
                  filters.last_meeting_date && filters.last_meeting_date.from
                    ? new Date(filters.last_meeting_date.from)
                    : ''
                }
                onChange={(date) => onChangeInputFromTo('last_meeting_date', date, 'from')}
                label='Last Meeting Date from'
                isClearable
                placeholder='mm/dd/yyyy'
                dateFormat='MM/dd/yyyy'
              />
            </Col>
            <Col md='3'>
              <CustomDatePicker
                selected={
                  filters.last_meeting_date && filters.last_meeting_date.to
                    ? new Date(filters.last_meeting_date.to)
                    : ''
                }
                onChange={(date) => onChangeInputFromTo('last_meeting_date', date, 'to')}
                label='Last Meeting Date to'
                isClearable
                placeholder='mm/dd/yyyy'
                dateFormat='MM/dd/yyyy'
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
          <Row>
            <Col>
              <Button className='btn-gold btn btn-sm float-right' onClick={onSearchClick}>
                Search
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Collapse>
    </Card>
  )
}

export default TableFilters
